var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"max-fill",attrs:{"size":"medium","placeholder":"请选择选项","value":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }